import React from 'react';

import '../styles/temp.css';

import logo from '../assets/logo.png'; // Import the logo image

/**
 *
 */
const Header = ({ hideLoginButton = false }) => {
  return (
    <header>
      <div className="header-container">
        {/* Left Side: Logo and Text */}
        <a href="/" className="header-left">
          {/* Replace the logo placeholder with the actual image */}
          <img src={logo} alt="Nura Logo" className="logo" />
        </a>

        {/* Right Side: Location and Login */}
        <div className="header-right">
          {/* Location */}

          {/* Login Button */}
          {!hideLoginButton && (
            <button className="login-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zm-4 7a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
